// The backend/frontend parity test keeps these scrape-rejection categories synchronized.
export const REFRESH_FAILURE_REASON_KEY: Record<string, string> = {
  http_error: 'articles.list.refresh_failed.reason.http_error',
  soft_404: 'articles.list.refresh_failed.reason.soft_404',
  off_domain_redirect: 'articles.list.refresh_failed.reason.off_domain_redirect',
  auth_wall: 'articles.list.refresh_failed.reason.auth_wall',
  error_page: 'articles.list.refresh_failed.reason.error_page',
  empty_content: 'articles.list.refresh_failed.reason.thin_content',
  thin_content: 'articles.list.refresh_failed.reason.thin_content',
};

export const REFRESH_FAILURE_UNKNOWN_KEY = 'articles.list.refresh_failed.reason.unknown';

export const refreshFailureReasonKey = (reason?: string | null): string =>
  (reason && REFRESH_FAILURE_REASON_KEY[reason]) || REFRESH_FAILURE_UNKNOWN_KEY;
